export default function FooterComp () {
    return (
      <div className="bg-green-700 text-white text-center py-4">
        <p>&copy; {new Date().getFullYear()} Grey Techs. All rights reserved.</p>
      </div> 
    );
};